import { Input, useBreadcrumbRoutes, Wrapper } from '@maxtropy/components';
import { Layout } from 'antd';
import { Dayjs } from 'dayjs';
import React, { createContext, Key, useState } from 'react';
import styles from './index.module.scss';
import DragResize from '@/components/DragResize';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import EnergyTree from './components/EnergyTree';
import RightContent from './components/RightContent';

const { Content, Sider } = Layout;

type RangeValue = [Dayjs | null, Dayjs | null] | null;

export const GlicoUnitComsumptionContext = createContext<{
  groupId?: number;
  unitId?: Key;
  setGroupId?: (groupId: number) => void;
  setUnitId?: (unitId: Key | undefined) => void;
  showDetail?: boolean;
  setShowDetail?: (showDetail: boolean) => void;
  setTime?: (time: RangeValue) => void;
  time?: RangeValue;
}>({});

const GlicoUnitComsumption = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [openSider, setOpenSider] = useState(true);
  const [groupId, setGroupId] = useState<number>();
  const [unitId, setUnitId] = useState<Key>();

  // 初始值
  const [siderWidth, setSiderWidth] = useState(260);
  // 拖拽状态
  const [dragStatus, setDragStatus] = useState(false);

  const dragChange = (width: number) => {
    if (openSider) {
      setSiderWidth(width);
    }
  };

  return (
    <Wrapper routes={breadcrumbRoutes?.routes} hasPadding={false}>
      <GlicoUnitComsumptionContext.Provider value={{ groupId, unitId, setGroupId, setUnitId }}>
        <Layout className={styles.layout}>
          <Sider
            className={styles.siderDemo}
            width={openSider ? siderWidth : 0}
            style={{ transition: dragStatus ? 'none' : 'all 0.2s' }}
          >
            <DragResize init={260} dragChange={dragChange} dragStatus={setDragStatus} />
            <EnergyTree />
          </Sider>
          <Content className={styles.content} style={{ marginLeft: openSider ? 10 : 0 }}>
            <div className="toggleBtn" style={{ left: openSider ? -30 : 0 }} onClick={() => setOpenSider(!openSider)}>
              {openSider ? <LeftOutlined /> : <RightOutlined />}
            </div>
            <RightContent />
          </Content>
        </Layout>
      </GlicoUnitComsumptionContext.Provider>
    </Wrapper>
  );
};

export default GlicoUnitComsumption;
